export default __webpack_public_path__ + "static/media/whylogo3.74746504.png";